<template>
  <el-dialog
    v-if="model"
    :title="model.category == 1 ? '维修服务请求' : '设备回收服务请求'"
    :visible.sync="visible"
    width="550px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      v-if="model && visible"
      ref="form"
      label-width="100px"
      :model="model"
      :rules="formRules"
      size="small"
    >
      <el-form-item
        label="中间商"
        prop="dealer_id"
        v-if="auth.isPlatformUser()"
      >
        <dealer-select
          :add="true"
          style="width: 100%"
          :val="model.dealer_id"
          @change="model.dealer_id = $event"
        ></dealer-select>
        <div
          class="text-danger font-12"
          style="line-height: 1.4em; margin-top: 5px"
          v-if="
            customerDeviceDealer.dealer_id &&
            model.dealer_id &&
            customerDeviceDealer.dealer_id != model.dealer_id
          "
        >
          注：此中间商与设备已绑定中间商（{{
            customerDeviceDealer.dealer.name
          }}）不匹配，若确认，提交后该设备的中间商将变更为此中间商。
        </div>
      </el-form-item>
      <el-form-item label="中间商联系人" prop="quest_dealer_contact_id">
        <DealerContactSelect
          :add="true"
          :dealerID="model.dealer_id"
          v-model="model.quest_dealer_contact_id"
        >
        </DealerContactSelect>
      </el-form-item>
      <el-form-item label="最终客户" prop="customer_id">
        <customer-select
          :add="true"
          :category="6"
          :val="model.customer_id"
          @change="model.customer_id = $event"
          @info="getCustomerInfo"
        ></customer-select>
      </el-form-item>
      <el-form-item label="客户联系人" prop="customer_contact_id">
        <CustomerContactSelect
          :add="true"
          :customerID="model.customer_id"
          :val="model.customer_contact_id"
          @change="model.customer_contact_id = $event"
        ></CustomerContactSelect>
      </el-form-item>
      <el-form-item label="客户设备" prop="customer_device_id">
        <CustomerDeviceSelect
          v-if="visible"
          :add="true"
          :dealerID="model.dealer_id"
          :customerID="model.customer_id"
          :val="model.customer_device_id"
          @change="model.customer_device_id = $event"
          @info="getDeviceInfo"
        >
        </CustomerDeviceSelect>
      </el-form-item>
      <el-form-item label="设备地址" prop="customer_device_address_id">
        <CustomerDeviceAddressSelect
          :add="true"
          :customerID="model.customer_id"
          v-model="model.customer_device_address_id"
        ></CustomerDeviceAddressSelect>
      </el-form-item>
      <el-form-item
        label="设备运行时长"
        prop="customer_device_id"
        v-if="model.customer_device_id"
      >
        <el-input
          style="width: 100%"
          size="small"
          v-model.number="model.device_running_time"
          type="number"
          placeholder="运行时长"
          min="0"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        label="设备应用工艺"
        prop="customer_device_id"
        v-if="model.customer_device_id"
      >
        <el-cascader
          v-model="model.device_application"
          style="width: 100%"
          :options="DeviceApplicationOptions"
          :props="{ checkStrictly: true }"
          clearable
        ></el-cascader>
      </el-form-item>
      <!-- <el-form-item label="联系人" prop="contact_name">
        <el-input
          v-model="model.contact_name"
          placeholder="客户联系人"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="contact_mobile">
        <el-input
          maxlength="11"
          v-model="model.contact_mobile"
          placeholder="客户联系电话"
        ></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="客户设备">
        <el-select
          v-model="model.customer_device_id"
          filterable
          style="width: 100%"
          placeholder="请选择"
          size="small"
        >
          <el-option
            v-for="item in devices"
            :key="item.id"
            :label="item.serial_number"
            :value="item.id"
          >
            <span>{{ item.serial_number }}</span>
            <span class="text-info-12"
              >({{ item.item_category.whole_name.replace(/,/g, '-') }})</span
            >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="服务需求类型" prop="sub_category">
        <el-select
          style="width: 100%"
          v-model="model.cmm_category"
          filterable
          placeholder="请选择"
          size="small"
        >
          <el-option
            v-for="item in ServiceQuestCMMCategory"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题分类" prop="sub_category">
        <el-select
          style="width: 100%"
          v-model="model.sub_category"
          filterable
          placeholder="请选择"
          size="small"
        >
          <el-option
            v-for="item in serviceQuestCategoryOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="详细描述">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入请求描述内容"
          v-model="model.desc"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="图片" class="long">
        <el-upload
          accept=".jpg,.png,.jpeg"
          class="upload-small"
          multiple
          :action="uploadUrl"
          :headers="uploadHeader"
          :on-error="onError"
          :on-remove="onRemove"
          :on-success="onSuccess"
          :file-list="fileList"
          list-type="picture-card"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="视频" class="long">
        <VideoUploader
          v-model="model.desc_videos"
          v-if="visible"
        ></VideoUploader>
      </el-form-item>
      <!-- <el-form-item label="紧急程度" v-if="model.category == 1">
        <el-select
          v-model="model.level"
          style="width: 100%"
          placeholder="请选择"
          size="small"
        >
          <el-option
            v-for="(label, value) in ServiceQuestLevelMap"
            :key="value"
            :label="label"
            :value="parseInt(value)"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  createCustomerContact,
  updateCustomerContact,
  customerDeviceList,
  createServiceQuest,
  updateServiceQuest,
  ccmCategoryList,
} from '../service/getData'
import CustomerSelect from '../components/select/customer_select'
import CustomerContactSelect from '../components/select/customer_contact_select'
import DealerContactSelect from '../components/select/dealer_contact_select'
import CustomerDeviceSelect from '../components/select/customer_device_select'
import CustomerDeviceAddressSelect from '../components/select/customer_device_address_select'
import DealerSelect from '../components/select/dealer_select'
import {
  ServiceQuestLevelMap,
  ServiceQuestSourceMap,
  DeviceApplicationOptions,
} from '@/config/global.js'
import {
  ServiceQuestCategory,
  ServiceQuestCMMCategory,
  ServiceQuestCMMCategoryTextMap,
} from '../config/global'
import auth from '@/util/auth'
import VideoUploader from './VideoUploader.vue'
import { urlPerfix } from '@/config/env'
import store from '@/store/store'

export default {
  components: {
    CustomerSelect,
    DealerSelect,
    CustomerContactSelect,
    DealerContactSelect,
    CustomerDeviceSelect,
    CustomerDeviceAddressSelect,
    VideoUploader,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      } else {
        this.customerDeviceDealer = {
          dealer_id: this.model.dealer.id,
          dealer: this.model.dealer,
        }
        this.handleOpen()
      }
    },
    'model.customer_id': function () {
      if (this.model.customer_id > 0) {
        this.requestCustomerDevices()
      } else {
        this.devices = []
      }
    },
    'model.cmm_category': function (n, o) {
      if (o) {
        this.model.sub_category = ''
      }
    },
  },
  computed: {
    serviceQuestCategoryOptions() {
      if (this.model.cmm_category) {
        return this.cmm_categories
          .filter(
            (item) =>
              item.level == 2 &&
              item.whole_name.split(',')[0] == this.model.cmm_category,
          )
          .map((item) => {
            return item.name
          })
      } else {
        return []
      }
    },
  },
  data() {
    return {
      auth,
      DeviceApplicationOptions,
      ServiceQuestLevelMap,
      ServiceQuestCategory,
      ServiceQuestCMMCategory: [],
      visible: this.show,
      customerSelectorVisible: false,
      customerDeviceDealer: {},
      activeCustomers: [],
      devices: [],
      formRules: {
        customer_id: [
          {
            required: true,
            type: 'integer',
            min: 1,
            message: '请选择客户',
            trigger: 'change',
            transform(value) {
              return Number(value)
            },
          },
        ],
      },
      submiting: false,
      cmm_categories: [],
      customerIndustry: [],
      uploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      fileList: [],
    }
  },
  created() {
    this.getCategories()
  },
  methods: {
    handleOpen() {
      let fileList = []
      if (this.model.desc_imgs && this.model.desc_imgs.length > 0) {
        fileList = this.model.desc_imgs.map((item, index) => ({
          name: 'img' + index + 1,
          url: item.replaceAll('#', 'hashtag') + '?t=' + this.FileToken,
        }))
      }
      this.fileList = fileList
    },
    async getCategories() {
      let res = await ccmCategoryList()
      this.cmm_categories = res.data.list
      this.ServiceQuestCMMCategory = [
        ...new Set(
          res.data.list
            .filter((item) => item.father_id == 0)
            .map((v) => v.name),
        ),
      ]
    },
    selectedCustomer() {},
    getDeviceInfo(e) {
      this.model.device_running_time = e.running_time || 0
      let application = e.product_application || []
      if (application.length == 0 && this.customerIndustry.length > 0) {
        application = this.customerIndustry
      }
      this.model.device_application = application
      this.customerDeviceDealer = e || {}
      if (e && !this.model.dealer_id) {
        this.model.dealer_id = e.dealer_id
      }
    },
    getCustomerInfo(e) {
      this.customerIndustry = e.industry || []
    },
    async requestCustomerDevices() {
      if (!this.model.customer_id || this.model.customer_id == 0) {
        return
      }

      let res = await customerDeviceList({
        customer_id: this.model.customer_id,
        status: -1,
        sap_sync: -1,
        page: 0,
        size: 1000,
      })
      if (res.code == 0) {
        this.devices = res.data.list
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true

          // // let data = {}
          // // for (const key in this.model) {
          // //   const element = this.model[key]
          // //   if (!(element instanceof Object) || key == 'device_application') {
          // //     data[key] = element
          // //   }
          // // }

          // let data = {
          //   id: this.model.id || 0,
          //   dealer_id: this.model.dealer_id,
          //   quest_dealer_contact_id: this.model.quest_dealer_contact_id,
          //   customer_id: this.model.customer_id,
          //   customer_contact_id: this.model.customer_contact_id,
          //   customer_device_id: this.model.customer_device_id,
          //   customer_device_address_id: this.model.customer_device_address_id,
          //   device_running_time: this.model.device_running_time,
          //   device_application: this.model.device_application,
          //   cmm_category: this.model.cmm_category,
          //   sub_category: this.model.sub_category,
          //   desc: this.model.desc,
          //   status: this.model.status,
          //   level: this.model.level,
          //   oem_sap_code: this.model.oem_sap_code,
          //   oem_contact_name: this.model.oem_contact_name,
          //   oem_contact_phone: this.model.oem_contact_phone,
          //   product_number: this.model.product_number,
          //   delivery_date: this.model.delivery_date,
          //   warranty_type: this.model.warranty_type,
          //   fse_testing: this.model.fse_testing,
          //   factory: this.model.factory,
          //   dealer_contact_id: this.model.dealer_contact_id,
          //   new_product_sale_id: this.model.new_product_sale_id,
          //   repair_dealer_id: this.model.repair_dealer_id,
          //   repair_dealer_name: this.model.repair_dealer_name,
          // }

          let data = this.model

          if (data.id > 0) {
            let res = await updateServiceQuest(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await createServiceQuest(data)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
          this.submiting = false
        } else {
          this.submiting = false
          console.log('error submit!!')
        }
      })
    },

    onSuccess(response, file, fileList) {
      this.onFileChange(fileList)
    },

    onFileChange(fileList) {
      let fileArray = fileList.map((item) => {
        return item.url.includes('blob')
          ? item.response.data
          : item.url.split('?t=')[0]
      })
      this.model.desc_imgs = fileArray
    },

    onError(err, file, fileList) {
      console.log(err)
    },

    onRemove(file, fileList) {
      this.onFileChange(fileList)
    },
  },
}
</script>
